<script>
export default {
  name: "logoComponent",


}
</script>

<template>
    <img src="@/assets/Logo_of_the_Jogorku_Kenesh.png" class="logo"/>
</template>

<style scoped>
  .logo{
    height: 80%;
    display: flex;
    max-width: 100%;
  }
  .logoComponentArea{
    height: 100%;
    display: flex;
    align-items: center;
  }


</style>